import { render, staticRenderFns } from "./_changePw.vue?vue&type=template&id=599aa561&lang=pug&"
import script from "./_changePw.vue?vue&type=script&lang=js&"
export * from "./_changePw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports